"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7393],{

/***/ 87393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11496);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45962);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59636);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76939);
// @mui






// @mui

// components
// sections



var Item = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        backgroundColor: theme.palette.background.neutral
    }, theme.typography.body2), {
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
        paddingBottom: 30,
        "&:hover": {
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        },
        cursor: "pointer"
    });
});
var Header = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 70,
        borderRadius: 25,
        padding: 5
    }, theme.typography.body1), {
        color: "#fff"
    });
});
// ----------------------------------------------------------------------
function HomeMenu() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
            container: true,
            spacing: 3,
            component: _components_animate__WEBPACK_IMPORTED_MODULE_3__/* .MotionViewport */ .DG,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inDown,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.car */ .sH.car,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#19b389"
                                        },
                                        children: " 600 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "\xd4n thi GPLX \xf4 t\xf4",
                                            src: "/icons/car.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "\xd4n Thi GPLX \xf4 t\xf4"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inRight,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.bike */ .sH.bike,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#3e67c3"
                                        },
                                        children: "200"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "\xd4n thi GPLX xe m\xe1y",
                                            src: "/icons/motorcycle.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "\xd4n Thi GPLX xe m\xe1y"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inLeft,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.situations */ .sH.situations,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#ed7a57"
                                        },
                                        children: "120"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "\xd4n thi M\xf4 phỏng",
                                            src: "/icons/simulator.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "\xd4n thi M\xf4 phỏng"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inLeft,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.practicalExam */ .sH.practicalExam,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#4f6183"
                                        },
                                        children: "8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "B\xe0i thi sa h\xecnh",
                                            src: "/illustrations/driving-school.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "B\xe0i thi sa h\xecnh"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inLeft,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.street */ .sH.street,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#c7906f"
                                        },
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "B\xe0i thi đường trường",
                                            src: "/illustrations/road.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "B\xe0i thi đường trường"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
                        variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_3__/* .varFade */ .EU)().inLeft,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_THIGPLX.blog */ .sH.blog,
                            style: {
                                textDecoration: "none"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                        sx: {
                                            backgroundColor: "#46a3ab"
                                        },
                                        children: "*"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: 1
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "Tin tức giao th\xf4ng",
                                            src: "/illustrations/police.png",
                                            height: 50,
                                            width: 50
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        children: "Tin tức giao th\xf4ng"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}


/***/ })

}]);